import React, { useContext, useEffect, useState } from 'react';
import { AuthenticationContext } from '../authentication/AuthenticationContext';
import { useApi } from '../api/useApi';
import { IonButton, IonContent, IonPage, IonText, IonList, IonItem } from '@ionic/react';

const Home: React.FC = () => {
  const { login, logout, accessToken, roles, initialized } = useContext(AuthenticationContext);
  const api = useApi();
  const [profile, setProfile] = useState<any>(null);
  const [allUsers, setAllUsers] = useState<any[]>([]);

  useEffect(() => {
    if (!accessToken) return;

    api.get('/me')
      .then(res => {
        setProfile(res.data);
        if (roles.includes('admin')) {
          return api.get('/users');
        }
      })
      .then(res => {
        if (res) setAllUsers(res.data);
      })
      .catch(err => {
        console.error('Error fetching data:', err);
      });
  }, [api, accessToken, roles]);

  if (!initialized) {
    return (
      <IonPage>
        <IonContent className="ion-padding">
          <IonText>Initializing...</IonText>
        </IonContent>
      </IonPage>
    );
  }

  return (
    <IonPage>
      <IonContent className="ion-padding">
        {!accessToken && <IonButton onClick={login}>Login</IonButton>}
        {accessToken && (
          <>
            <IonText>Welcome, {profile?.name || 'user'}!</IonText>
            <IonButton onClick={logout}>Logout</IonButton>
            {roles.includes('admin') && (
              <>
                <IonText>All Users:</IonText>
                <IonList>
                  {allUsers.map((user, index) => (
                    <IonItem key={index}>{user.name || user.email}</IonItem>
                  ))}
                </IonList>
              </>
            )}
          </>
        )}
      </IonContent>
    </IonPage>
  );
};

export default Home;